import {NgModule} from '@angular/core';
import {AppSharedModule} from 'app/app-shared.module';
import {ErrorDialogComponent} from 'app/main/@error-dialog/error-dialog.component';

@NgModule({
    imports: [
        AppSharedModule
    ],
    declarations: [
        ErrorDialogComponent
    ],
    entryComponents: [
        ErrorDialogComponent
    ]
})
export class ErrorDialogModule {

}
